import React, { useState } from 'react'
import { useEffect } from 'react';
import "../css/filters.css"
import axios from 'axios';


function Filters({filteredData,searchdata}) {



    const [array, setArray] = useState([]);

    const search = async()=>{
        if (searchdata && searchdata.length > 0) { // Check if searchdata is defined and not empty
            const res = await axios.get(`https://petme.onrender.com/api/pets/findpet?petcategory=${searchdata[0].petcategory}`);
            setArray(res.data);
          }
     }

     const uniqueBreeds = Array.from(new Set(array.map((pet) => pet.breed)));


  useEffect(()=>{
    search()
  },[searchdata,array])


   const[filterCategory, setFilterCategory] = useState({
        
       sex:'',
       age:'',
       breed:'',
       trained:'',
       neutered:'',
       vaccinated:'',

   })

   const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterCategory((prevState) => ({ ...prevState, [name]: value }));
    filteredData({ ...filterCategory, [name]: value });
  };
    

    const [visible1, setVisible1] = React.useState(false);
    const [visible2, setVisible2] = React.useState(false);
    const [visible3, setVisible3] = React.useState(false);
    const [visible4, setVisible4] = React.useState(false);
    const [visible5, setVisible5] = React.useState(false);
    const [visible6, setVisible6] = React.useState(false);

    return (
        <div className="col filter-column">
            <div className="filter-category row-lg-2 row-md-3 row-sm-6">
                <button className="filter-btn" onClick={() => {
                    setVisible1(!visible1)
                    setVisible2(false)
                    setVisible3(false)
                    setVisible4(false)
                    setVisible5(false)
                    setVisible6(false)
                }}>Sex</button>

                {visible1 &&
                    <div className="filters">
                        <button  name = "sex" value= "Female" onClick={handleChange} className="filter-option-btn">Female</button>
                        <button  name ="sex" value = "Male" onClick={handleChange} className="filter-option-btn">Male</button>
                    </div>
                }
            </div >


            <div className="filter-category row-lg-2 row-md-3 row-sm-6">
                <button className="filter-btn" onClick={() => {
                    setVisible1(false)
                    setVisible2(!visible2)
                    setVisible3(false)
                    setVisible4(false)
                    setVisible5(false)
                    setVisible6(false)
                }}>Breed</button>
                
                {visible2 &&
                    
                    <div className="filters" >
                    {uniqueBreeds.map((breed) => (
          <button name="breed" value={breed} onClick={handleChange} className="filter-option-btn" key={breed}>
            {breed}
          </button>
        ))}
                    </div>
                }
            </div >


            <div className="filter-category row-lg-2 row-md-3 row-sm-6">
                <button className="filter-btn" onClick={() => {
                    setVisible1(false)
                    setVisible2(false)
                    setVisible3(!visible3)
                    setVisible4(false)
                    setVisible5(false)
                    setVisible6(false)
                }}>Age</button>
                {visible3 &&
                    <div className="filters" >
                        <button  name = "age" value= "Baby" onClick={handleChange} className="filter-option-btn">Baby</button>
                        <button  name = "age" value= "Adolescent" onClick={handleChange} className="filter-option-btn">Adolescent</button>
                        <button  name = "age" value= "Adult" onClick={handleChange} className="filter-option-btn">Adult</button>
                        <button  name = "age" value= "Senior" onClick={handleChange} className="filter-option-btn">Senior</button>

                    </div>
                }
            </div >


            <div className="filter-category row-lg-2 row-md-3 row-sm-6">
                <button className="filter-btn" onClick={() => {
                    setVisible1(false)
                    setVisible3(false)
                    setVisible4(!visible4)
                    setVisible5(false)
                    setVisible6(false)
                    setVisible2(false)
                }}>Trained</button>
                {visible4 &&
                    <div className="filters" >
                        <button  name = "trained" value= "Yes" onClick={handleChange} className="filter-option-btn">Yes</button>
                        <button  name = "trained" value= "No" onClick={handleChange} className="filter-option-btn">No</button>
                    </div>
                }
            </div >


            <div className="filter-category row-lg-2 row-md-3 row-sm-6">
                <button className="filter-btn" onClick={() => {
                    setVisible1(false)
                    setVisible2(false)
                    setVisible3(false)
                    setVisible4(false)
                    setVisible5(!visible5)
                    setVisible6(false)
                }}>Neutered</button>

                {visible5 &&
                    <div className="filters" >
                        <button  name = "neutered" value= "Yes" onClick={handleChange} className="filter-option-btn">Yes</button>
                        <button  name = "neutered" value= "No" onClick={handleChange} className="filter-option-btn">No</button>
                    </div>

                }

            </div >

            <div className="filter-category row-lg-2 row-md-3 row-sm-6">
                <button className=" filter-btn" onClick={() => {
                    setVisible1(false)
                    setVisible2(false)
                    setVisible3(false)
                    setVisible4(false)
                    setVisible5(false)
                    setVisible6(!visible6)
                }}>Vaccinated</button>

                {visible6 &&
                    <div className="filters" >
                        <button  name = "vaccinated" value= "Yes" onClick={handleChange} className="filter-option-btn">Yes</button>
                        <button  name = "vaccinated" value= "No" onClick={handleChange} className="filter-option-btn">No</button>
                    </div>

                }

            </div >


        </div>



    );



}



export default Filters








